import React, { FC } from 'react'

import { Label } from './radioButton.styles'

interface IRadioButtonProps {
  name: string
  label?: string
  checked: boolean
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const RadioButton: FC<IRadioButtonProps> = ({ label, name, onChange, checked }) => {
  return (
    <Label>
      <input type="radio" onChange={onChange} name={name} checked={checked} />
      {label && <span>{label}</span>}
    </Label>
  )
}

export default RadioButton
